import { trackEvent } from "../events";

// trackOnce skips the event if it was already sent for the same id.
export default {
	data() {
		return {
			trackedIds: new Set(),
		};
	},
	methods: {
		trackEvent,
		trackOnce(eventKey, id, data) {
			if (!id) return;
			const key = `${eventKey}:${id}`;
			if (this.trackedIds.has(key)) return;
			this.trackedIds.add(key);
			trackEvent(eventKey, data);
		},
	},
};
